import { useState } from "react";
import { Typography, Modal, Button } from "antd";
import "./footer.scss";

export const Footer = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleFeedbackClick = () => {
    setIsModalOpen(true);
  };

  return (
    <footer className="app-footer">
      <Typography>ООО «Интэнт». Санкт-Петербург</Typography>
      <span
        className="app-footer__feedback-link"
        onClick={handleFeedbackClick}
      >
        Обратная связь
      </span>
      <Modal
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width={600}
        title={<span className="feedback-modal__title">Обратная связь</span>}
        centered
        style={{ borderRadius: 16 }}
      >
        <div className="feedback-modal__description">
          По вопросам связанным с использованием сервиса можно обращаться по нашим каналам связи
        </div>
        <div className="feedback-modal__row">
          <span className="feedback-modal__label">Позвонить</span>
          <a className="feedback-modal__link" href="tel:+79313376642">
            +7 (931) 337-6642
          </a>
        </div>
        <div className="feedback-modal__row">
          <span className="feedback-modal__label">Написать</span>
          <a className="feedback-modal__link" href="mailto:help@builddocs.ru">
            help@builddocs.ru
          </a>
        </div>
        <div className="feedback-modal__row feedback-modal__row--last">
          <span className="feedback-modal__label">Написать в Телеграм</span>
          <a
            className="feedback-modal__link"
            href="https://t.me/BuildDocs_support"
            target="_blank"
            rel="noopener noreferrer"
          >
            @BuildDocs_support
          </a>
        </div>
        <div className="feedback-modal__divider" />
        <Button
          onClick={() => setIsModalOpen(false)}
          type="primary"
        >
          Закрыть
        </Button>
      </Modal>
    </footer>
  );
};
